
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, ProjectAccountViewModel } from "@tylertech/tyler-api-types";

/**
 * ProjectAccountLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ProjectAccountLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<ProjectAccountViewModel[]>> {
        return this.$apiService.sendAuth("IProjectAccountLookupService/Lookup", pCriteria);
    }
}
